export default "__VITE_ASSET__DLd0xaW4__"